import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from './../../environments/environment';
import { map } from 'rxjs/operators';
const API_URL = environment.apiUrl;

@Injectable({
  providedIn: 'root'
})
export class CityService {


  constructor(private http: HttpClient) { }
  getAll(query): any {
    return this.http.get<any[]>(API_URL + `cities`, {params: query});
  }
  create(data): any{
    return this.http
    .post(API_URL + 'cities', data)
      .pipe(map(res => {
        return res;
    }));
  }
  get(id): any {
    return this.http.get<any[]>(API_URL + `cities/` + id);
  }
  search(keyword): any {
  return this.http.get<any[]>(API_URL + `cities/search/` + keyword).pipe(map(res => {
    return res;
  }));
  }
  update(data, id): any{
    return this.http
    .put(API_URL + 'cities/' + id , data)
      .pipe(map(res => {
        return res;
    }));
  }

  active(id): any{
  return this.http
  .put(API_URL + 'cities/' + id + '/active/',null)
    .pipe(map(res => {
      return res;
  }));
}
inactive(id): any{
  return this.http
  .put(API_URL + 'cities/' + id + '/inactive/', null)
    .pipe(map(res => {
      return res;
  }));
}

  changeStatus(id, status): any{
    return this.http
    .put(API_URL + 'cities/' + id + '/' + status , null)
      .pipe(map(res => {
        return res;
    }));
  }

  changeStatusDelete(id, status): any{
    return this.http
    .delete(API_URL + 'cities/' + id + '/' + status )
      .pipe(map(res => {
        return res;
    }));
  }

  delete(id): any{
    return this.http
    .delete(API_URL + 'cities/' + id + '/delete')
      .pipe(map(res => {
        return res;
    }));
  }
}
